// Core
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import APIKit from "../../../Middleware/axiosConfig";
import { notifyError } from "Services/Utils/toastNotification";
import { API_END_POINTS } from "Middleware/apiEndpoints";

export const fetchNotifications = createAsyncThunk(
  "notifications/fetchNotifications",
  async ({ page, limit }) => {
    const response = await APIKit().get(
      `${API_END_POINTS.getNotifications}?page=${page}&limit=${limit}`
    );
    if (response?.status === 200) {
      return response.data.data.data_list; // Assuming the data structure you provided
    } else {
      throw new Error(response.data.message);
    }
  }
);

export const markNotificationAsRead = createAsyncThunk(
  "notifications/markAsRead",
  async (notificationId) => {
    const response = await APIKit().put(
      `${API_END_POINTS.getNotifications}/${notificationId}`,
      {
        is_read: true,
      }
    );
    if (response?.status === 200) {
      return notificationId;
    } else {
      throw new Error(response.data.message);
    }
  }
);

const notificationsSlice = createSlice({
  name: "notifications",
  initialState: {
    notifications: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    // Handle fetching notifications
    builder
      .addCase(fetchNotifications.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.isLoading = false;
        state.notifications = action.payload; // Set notifications
      })
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message; // Set error message
        notifyError(action.error.message); // Show error notification
      })
      // Handle marking notification as read
      .addCase(markNotificationAsRead.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(markNotificationAsRead.fulfilled, (state, action) => {
        state.isLoading = false;
        const notificationId = action.payload;
        const notification = state.notifications.find(
          (notif) => notif.notification_id === notificationId
        );
        if (notification) {
          notification.is_read = true; // Update the is_read status
        }
      })
      .addCase(markNotificationAsRead.rejected, (state, action) => {
        state.isLoading = false;
        notifyError(action.error.message); // Show error notification
      });
  },
});

export default notificationsSlice.reducer;
